/* eslint-disable react/prop-types -- the project does not use prop-types */
// Small coloured "PST · 8:30 PM" label: the customer's local timezone and time now.
// Used inside table cells, where hooks can't run in the column render function.
// Logic lives in utils/leadTimezone.js (ZIP first, then browser zone, else nothing).
import { useMemo } from 'react';
import { Tooltip, Typography } from 'antd';
import { resolveLeadTimeZone, zoneAbbr, zoneTime, zoneColor, useMinuteClock } from '../../utils/leadTimezone';

const { Text } = Typography;

// fontSize: same as the name next to it (names are 14px in tables).
export default function LeadLocalTime({ zipCode, browserTimeZone, fontSize = 14 }) {
  const tz = useMemo(
    () => resolveLeadTimeZone({ personalInfo: { zipCode }, browserInfo: { timeZone: browserTimeZone } }),
    [zipCode, browserTimeZone]
  );
  const now = useMinuteClock(Boolean(tz));
  if (!tz) return null;

  const date = new Date(now);
  const abbr = zoneAbbr(tz.zone, date);
  return (
    <Tooltip
      title={
        tz.source === 'zip'
          ? `Customer local time (from ZIP ${tz.zip})`
          : `Customer local time (from browser: ${tz.zone})`
      }
    >
      <Text
        style={{
          fontSize,
          fontWeight: 700,
          color: zoneColor(abbr),
          whiteSpace: 'nowrap',
          cursor: 'default',
        }}
      >
        {abbr} · {zoneTime(tz.zone, date)}
      </Text>
    </Tooltip>
  );
}
